import ConfigProvider from '../config/ConfigProvider';
import { Environment, Locale, ShopBundle } from '../types';

import ErrorContextProvider from './ErrorContextProvider';
import I18nProvider from './I18nProvider';
import Providers from './Providers';
import SentryErrorBoundary from './SentryErrorBoundary';

export interface CoreProvidersProps {
  errorContainerId: string;
  shopBundle: ShopBundle;
  domain: string;
  locale: Locale;
  csrfToken?: string; // csrfToken might be undefined for a form not needing API calls (for ex on registration page)
  env: Environment;
}

/**
 * Pack in one place all the providers that are generally needed in our app.
 */
const CoreProviders: React.FC<CoreProvidersProps> = ({
  errorContainerId,
  shopBundle,
  domain,
  locale,
  csrfToken,
  env,
  children,
}) => {
  return (
    <ConfigProvider env={env} shopBundle={shopBundle}>
      <I18nProvider shopBundle={shopBundle} locale={locale}>
        <SentryErrorBoundary>
          <ErrorContextProvider errorContainerId={errorContainerId}>
            <Providers
              shopBundle={shopBundle}
              domain={domain}
              locale={locale}
              csrfToken={csrfToken}>
              {children}
            </Providers>
          </ErrorContextProvider>
        </SentryErrorBoundary>
      </I18nProvider>
    </ConfigProvider>
  );
};

export default CoreProviders;
